import { SEARCH_JOB } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEARCH_JOB.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_JOB.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEARCH_JOB.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
